module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step1_Image16.deb53994.webp";